import { compose, withProps } from 'recompose'
import Product from './Product'
import { getReviewsLink } from '../../../OneColumnSearchResultPage/helpers'

const withPriceInformation = withProps(({
  hasStore,
  price,
  hasMapPrice,
  hasActiveVehicle,
  hasStaggeredFitment,
  zeroPriceItemMessage,
  seePriceIncartMessage,
  url
}) => ({
  isShowStartingAtPrice: hasStore && Number(price) > 0 && (!hasActiveVehicle || hasStaggeredFitment) && !hasMapPrice,
  isShowCallStoreForPrice: hasStore && (isNaN(price) || Number(price) === 0) && !hasMapPrice,
  isShowPrice: hasStore && Number(price) > 0 && hasActiveVehicle && !hasStaggeredFitment && !hasMapPrice,
  mapShowPhoneNumber: Boolean(hasStore && hasMapPrice && seePriceIncartMessage.match(/call/i)),
  reviewsLink: getReviewsLink(url)
}))

export default compose(
  withPriceInformation
)(Product)
